import React from 'react'
import Navbar from '../components/profile/Navbar'
import FormWrapper from '../components/profile/FormWrapper'
import styled from 'styled-components'

const Signup = () => {
  return (
    <Wrapper>
        <Navbar/>
        <FormWrapper />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  overflow: auto;
  height: 100vh;
`;


export default Signup